import API from '~pages/api';
import KnowledgeBaseArticle from '~pages/knowledge-base/article';
export default {
    api: API,
    'knowledge-base-article': KnowledgeBaseArticle,
};
